import { ZfLoadingSpinner } from '@zafire/react';
import { useTranslation } from 'react-i18next';
import { useActiveDomicile, useCalculatorsUrls } from '../api';
import { CalculatorCard } from '../components/calculators';
import { Domicile } from '../enums';

export const CalculatorsScreen = () => {
    const { t } = useTranslation();
    const { data: calculators, isLoading, isSuccess } = useCalculatorsUrls();
    const activeDomicile = useActiveDomicile();

    return (
        <div className="calculator-screen flex-1">
            <h4 className="calculator-screen__title">{t('calculatorsTitle')}</h4>
            {isLoading && <ZfLoadingSpinner style={{ position: 'absolute', top: '50%', left: '50%' }} />}
            {isSuccess && (
                <>
                    {activeDomicile === Domicile.CH ? (
                        <div className="calculator-list">
                            <CalculatorCard
                                imageKey={'TAXES'}
                                title={t('calculatorsTaxesTitle')}
                                description={t('calculatorsTaxesDescription')}
                                buttonLabelText={t('calculatorsTaxesButtonLabel')}
                                calculatorUrl={calculators.taxUrl}
                            />
                            <CalculatorCard
                                imageKey={'PENSION'}
                                title={t('calculatorsPensionTitle')}
                                description={t('calculatorsPensionDescription')}
                                buttonLabelText={t('calculatorsPensionButtonLabel')}
                                calculatorUrl={calculators.pensionUrl}
                            />
                            <CalculatorCard
                                imageKey={'SAVINGS'}
                                title={t('calculatorsSavingTitle')}
                                description={t('calculatorsSavingDescription')}
                                buttonLabelText={t('calculatorsSavingButtonLabel')}
                                calculatorUrl={calculators.savingUrl}
                            />
                        </div>
                    ) : (
                        <div className="calculator-list">
                            <CalculatorCard
                                imageKey={'SAVINGS'}
                                title={t('calculatorsSavingTitle')}
                                description={t('calculatorsSavingDescription')}
                                buttonLabelText={t('calculatorsSavingButtonLabel')}
                                calculatorUrl={calculators.savingUrl}
                            />
                            <div className="calculator-card" />
                            <div className="calculator-card" />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
